import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import { Helmet } from 'react-helmet-async';
import { Table, Button, InputGroup, Input } from 'rsuite';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Loader } from 'rsuite';
import { Pagination } from 'rsuite';
import { useAuth} from '../../AuthContext';
import axios from 'axios';

import SearchIcon from '@rsuite/icons/Search';
import CheckRoundIcon from "@rsuite/icons/CheckRound";
import TrashIcon from '@rsuite/icons/Trash';

const { Column, HeaderCell, Cell } = Table;

function DelticomPage() {
  const { auth } = useAuth();
  const [orders, setOrders] = useState([]);
  const navigate = useNavigate(); // Initialize useNavigate
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [invoiceGenerated, setInvoiceGenerated] = useState(false);
  const [activePage, setActivePage] = React.useState(1);
  const [page, setPage] = useState(0);  
  const [totalPages, setTotalPages] = useState(1);  
  const [searchInput, setSearchInput] = useState('');  

  const deleteOrder = async (orderId) => {
    if (!window.confirm('Är du säker på att du vill radera denna order?')) {
      return; // User canceled the deletion
    }
    setLoading(true)

    try {
      const response = await axios.delete(`${process.env.REACT_APP_BASE_URL}/delticom/delete-order?id=${orderId}`, {
        headers: {
          'Authorization': `Bearer ${auth.token}`,
          'Content-Type': 'application/json'
        }
      });
  
      if (response.status === 200) {
        toast.warning('Ordern har raderats.', {
          position: 'bottom-right'
        });
        setOrders(prevOrders => prevOrders.filter(ord => ord.id !== orderId));
      } else {
        toast.error('Misslyckades att radera ordern.', {
          position: 'bottom-right'
        });
      }
    } catch (error) {
      toast.error('Misslyckades att radera ordern.', {
        position: 'bottom-right'
      });
    } finally {
      setLoading(false)
    }
  }

  function showHandledSet(handled){
    setInvoiceGenerated(handled);
    if(handled){
        toast.info("Visar hanterade ordrar.", {position: 'bottom-right'});
    }
    else{
        toast.success("Visar nya ordrar.", {position: 'bottom-right'});
    }
  }

  function search(orderNr) {
          setSearchInput(orderNr);  // Update the searchInput state
          setPage(0);              // Reset to the first page
          fetchOrders(0, orderNr); // Fetch the first page with the search term
        }
      
        useEffect(() => {
          fetchOrders();
        }, [invoiceGenerated])

  const fetchOrders = async (currentPage = 0, orderNr = '') => {
        setLoading(true);
    
        try{
          const response = await fetch(`${process.env.REACT_APP_BASE_URL}/delticom/orders?page=${currentPage}&invoiceGenerated=${invoiceGenerated}&size=15&orderNr=${encodeURIComponent(orderNr)}`, {
            method: "GET",
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth.token}`
            }
          });
    
          if(response.ok){
            const data = await response.json();
            setOrders(data.content);
            setPage(data.number);
            setTotalPages(data.totalPages);
          }
          else{
            const errorText = await response.text();
            throw new Error(`Misslyckade att hämta fakturor: ${errorText}`);
          }
        }catch(error){
          toast.error(error.message, {
            position: 'bottom-right'
          });
        } finally{
          setLoading(false);
        }
      }

      const createInvoice = async () => {
        if (!window.confirm('Är du säker på att du vill skapa en faktura?')) {
            return; // User canceled the deletion
        }
    
        setLoading(true);
    
        try {
          const response = await fetch(`${process.env.REACT_APP_BASE_URL}/invoice/create-invoice`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Authorization': `Bearer ${auth.token}`
            }
          });
    
          const result = await response.json();
    
          if (response.ok) {
            toast.success(result.message, {
              position: 'bottom-right'
            });
            fetchOrders();
          } else {
            toast.error(result.message, {
              position: 'bottom-right'
            });
          }
        } catch (error) {
          console.log(error);
          toast.error('Misslyckades att skapa faktura: ', error, {
            position: 'bottom-right'
          });
        } finally {
          setLoading(false);
        }
      };

  return (
    <>
      <Helmet>
        <title>{`Ordrar`}</title>
      </Helmet>
      <div className="px-5 pt-4 w-100">
        {invoiceGenerated ? (
                <>
                <h4 className="mb-2">Hanterade ordrar</h4>
                <p className="text-muted">Översikt av hanterade ordrar från delticom.</p>
                </>
            ) : (
                <>
                <h4 className="mb-2">Nya ordrar</h4>
                <p className="text-muted">Översikt av nya ordrar från delticom.</p>
                </>
        )}
        <hr />
        <div className="d-flex justify-content-end">
            <div className="d-flex mb-2">

            {invoiceGenerated ? (
                  <Button className='me-2' color='cyan' appearance="primary" onClick={() => showHandledSet(false)}>Visa nya ordrar</Button>
                ) : (
                  <Button className='me-2' color='cyan' appearance="primary" onClick={() => showHandledSet(true)}>Visa hanterade ordrar</Button>
            )}


                <Button className='me-2' color='orange' disabled={loading} appearance="primary" onClick={createInvoice}>
                  {loading ? <Loader /> : "Skapa faktura"}
                  </Button>
                <div>
                <InputGroup>
                    <Input size="md" placeholder={'Sök RD nummer'} onChange={(value) => search(value)} />
                    <InputGroup.Button>
                    <SearchIcon />
                    </InputGroup.Button>
                </InputGroup>
                </div>
            </div>
        </div>


        <Table
          className='rounded'
          autoHeight
          cellBordered
          data={orders}
          bordered
          autoWidth
        >
          {/* Define the columns with appropriate width */}
          <Column flexGrow={1}>
            <HeaderCell>Order nummer</HeaderCell>
            <Cell>
              {(rowData) => (
                <Link 
                  to={`/admin/order?id=${rowData?.id}`} 
                  key={rowData.id}
                  className='text-primary'
                  style={{ color: 'inherit' }} // Remove underline & keep text color
                >
                  {rowData.orderNr}
                </Link>
              )}
            </Cell>
          </Column>

  
          <Column width={150} align='center'>
            <HeaderCell>Datum</HeaderCell>
            <Cell dataKey="dateCreated" />
          </Column>
  
          <Column width={80} align='center'>
            <HeaderCell>Hanterad</HeaderCell>
            <Cell>
            {(rowData) =>
            rowData.filled ? (
              <CheckRoundIcon style={{ color: "green" }} />
            ) : null
          }
            </Cell>
            </Column>

  
            <Column width={80} align="center">
              <HeaderCell></HeaderCell>
              <Cell>
                {(rowData) => (
                  <TrashIcon 
                    style={{ cursor: "pointer", color: "red" }} 
                    onClick={() => deleteOrder(rowData.id)} 
                  />
                )}
              </Cell>
            </Column>

        </Table>
        <Pagination
          size="md"
          className="mt-2"
          total={totalPages * 15}
          limit={15}
          maxButtons={15}
          activePage={activePage}
          onChangePage={(page) => {
            setActivePage(page);       // Update the active page
            fetchOrders(page - 1, searchInput); // Include the current search input
          }}
        />
      </div>
    </>
  );
}

export default DelticomPage;
